export default "__VITE_ASSET__300bce4e__"